import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MonthlyReportTemplate } from 'components/Templates'

const MonthlyReport: FC = () => {
  return (
    <Layout headline={'月次レポート'} iconPath={'/icon/white/revenue.svg'} title={'月次レポート'}>
      <MonthlyReportTemplate />
    </Layout>
  )
}

export default MonthlyReport
